function jsonResponse (status, res) {
    return { status, res }
  }
export { jsonResponse }